import { render, staticRenderFns } from "./flipchart2.vue?vue&type=template&id=3899ac7d&scoped=true&"
var script = {}
import style0 from "./flipchart2.vue?vue&type=style&index=0&id=3899ac7d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3899ac7d",
  null
  
)

export default component.exports